/**
 * TimeEstimate – "Estimated time: X min" display.
 */

interface TimeEstimateProps {
  minutes: number;
  className?: string;
}

export default function TimeEstimate({ minutes, className = '' }: TimeEstimateProps) {
  const display =
    minutes >= 60
      ? `${Math.floor(minutes / 60)}h ${minutes % 60 > 0 ? `${minutes % 60}m` : ''}`
      : `${minutes} min`;

  return (
    <span className={`inline-flex items-center gap-1 text-xs text-stone-400 ${className}`}>
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      {display}
    </span>
  );
}
